import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { AdminUser, User } from "models/dbModels/users/User";
import { UserSearchFilterQuery } from "models/filters/users/UserSearchFilterQuery";

export class UsersApi {
    static CurrentUser = async () => axios.get<DataResponse<User>>(`api/v1/Users/CurrentUser`);
    static Search = async (query: UserSearchFilterQuery) => axios.post<PaginatedResponse<User[]>>(`api/v1/Users/Search`, query);
    static Add = async (query: User[]) => axios.post<DataResponse<number[]>>(`api/v1/Users/Add`, query);
    static Update = async (query: User[]) => axios.post<DataResponse<boolean>>(`api/v1/Users/Update`, query);
    static AdminSearch = async (query: UserSearchFilterQuery) => axios.post<PaginatedResponse<AdminUser[]>>(`api/v1/Users/AdminSearch`, query);
    static AdminAdd = async (query: AdminUser[]) => axios.post<DataResponse<number[]>>(`api/v1/Users/AdminAdd`, query);
    static AdminUpdate = async (query: AdminUser[]) => axios.post<DataResponse<boolean>>(`api/v1/Users/AdminUpdate`, query);
}